import { useDispatch } from 'react-redux';

export function useGlobalDispatch() {
  return useDispatch();
}
